const initialState = {
    refDataDropdowns: [],
    refDataDropdownsForSelectionBox: [],
};
export default initialState;